var map = {
	"./chapter-6.jpg": "5359",
	"./fan-made-video.jpg": "35d2",
	"./jungle.jpg": "d251",
	"./red-airplane.jpg": "5b11",
	"./summer.jpg": "8d4c",
	"./wake-island.jpg": "19d3",
	"./winners.jpg": "7936"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35ad";